module.exports = __webpack_public_path__ + "img/video_10.87d5e414.png";